import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import BaseInput from './base';

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

const validate = val =>
  string()
    .required('Enter your income')
    .matches(
      /^[1-9]\d{3,10}(\.[0-9]{2})?$/,
      'Annual Income must be at least $4,500'
    )
    .test(
      'is-over-4.5k',
      'Annual Income must be at least $4,500',
      value => Number(value) >= 4500
    )
    .validate(val.replace(/[^\d.]/g, '').toString())
    .then(() => null)
    .catch(err => err.errors?.join(', '));

const Input = inputProps => (
  <BaseInput
    label="My Yearly Income"
    type="number"
    name="income"
    maxLength={14}
    autoComplete="off"
    transparent
    useLocalState={false}
    {...inputProps}
  />
);

const Income = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    thousandSeparator
    prefix="$"
    allowNegative={false}
    onValueChange={values =>
      onChange({ ...values, name: 'income', type: 'number' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

Income.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string
};

Income.defaultProps = {
  onTouched: null,
  value: '',
  error: ''
};

export default Income;
